module.exports = __webpack_public_path__ + "img/Villa_Borna_46.7dc6d951.jpg";